import { render, staticRenderFns } from "./pay-wechat.vue?vue&type=template&id=39b482d7&scoped=true&lang=html&"
import script from "./pay-wechat.vue?vue&type=script&lang=js&"
export * from "./pay-wechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b482d7",
  null
  
)

export default component.exports